/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_viewer = {
    readonly isSbMobileGridToggleDisabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"Tile_viewer" | "TileTestVariant_viewer">;
    readonly " $refType": "SharedItemTile_viewer";
};
export type SharedItemTile_viewer$data = SharedItemTile_viewer;
export type SharedItemTile_viewer$key = {
    readonly " $data"?: SharedItemTile_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "fetchRegionalInfo",
    "variableName": "fetchRegionalInfo"
  },
  {
    "kind": "Variable",
    "name": "userCountryCode",
    "variableName": "userCountryCode"
  },
  {
    "kind": "Variable",
    "name": "userZipCode",
    "variableName": "userZipCode"
  }
];
return {
  "kind": "Fragment",
  "name": "SharedItemTile_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSbMobileGridToggleDisabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "isSbMobileGridToggleDisabled"
        }
      ],
      "storageKey": "isEnabled(key:\"isSbMobileGridToggleDisabled\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "Tile_viewer",
      "args": (v0/*: any*/)
    },
    {
      "kind": "FragmentSpread",
      "name": "TileTestVariant_viewer",
      "args": (v0/*: any*/)
    }
  ]
};
})();
(node as any).hash = '8cfaca8204633fc19eca8168a0da4cc7';
export default node;
